import { useNavigate } from 'react-router-dom';

import { NavigationService } from '../../../services/navigation.service';

import { Equipment, Client, Site, SectorIcon, Sector } from '@umanforge/common';

import { SitesIcon } from '../../../components/icons/sites_icon.component';
import { ClientsIcon } from '../../../components/icons/clients_icon.component';


interface EquipmentProps {
  equipment: Equipment;
  sectorOfEquipment: Sector | undefined;
  siteOfSector: Site | undefined;
  clientOfSite: Client | undefined;
  t: ( key: string ) => string;
}

export function EquipmentComponent( props: EquipmentProps ) {
  const { equipment, siteOfSector, clientOfSite, sectorOfEquipment, t } = props;

  const navigate = useNavigate();

  function openDetailsEquipment() {
    NavigationService.toEquipment( navigate, equipment.id, false );
  }

  return (
    <div
      className="relative flex px-24 py-4 mx-2 my-4 shrink-0 text-center justify-center items-center bg-gray-100 shadow-md drop-shadow-md overflow-hidden rounded-lg cursor-pointer transition ease-in-out hover:-translate-y-1 hover:scale-[105%] hover:drop-shadow-xl hover:z-10 duration-50"
      style={{ width: '26rem' }}
      onClick={ openDetailsEquipment }
    >
      <p className="text-lg font-semibold text-slate-600 text-center truncate mr-5">{equipment.name}</p>
      <div className='absolute flex flex-col w-20 px-2 my-2 items-center justify-around inset-y-0 right-0 text-xs font-medium text-slate-500 text-left'>
        <div className='flex gap-1 w-20'>
          <ClientsIcon className='fill-slate-500 w-3'/>
          <p className='w-full truncate'>{ clientOfSite ? clientOfSite.name : t( 'common:error.missing_client' ) }</p>
        </div>
        <div className='flex gap-1 w-20'>
          <SitesIcon className='fill-slate-500 w-3'/>
          <p className='w-full truncate'>{ siteOfSector ? siteOfSector.name : t( 'common:error.missing_site' ) }</p>
        </div>
        <div className='flex gap-1 w-20'>
          <SectorIcon className='fill-slate-500 w-3 h-4'/>
          <p className='w-full truncate'>{ sectorOfEquipment ? sectorOfEquipment.name : t( 'common:error.missing_sector' ) }</p>
        </div>
      </div>
    </div>
  );
}